module.exports = __webpack_public_path__ + "static/media/english.cd99a514.svg";